export default __webpack_public_path__ + "static/media/avatar_placeholder_5.7fdf7f51.jpg";